<div class="flex flex-wrap mt-4 min-w">
    <h1 class="w-full">Análisis de tema</h1>

    <h3 class="w-full">
        <p>
            ¡Bienvenido a nuestra herramienta de análisis de temas!
        </p>

        <p> Con nuestra tecnología, podrás buscar noticias relacionadas a un tema específico y obtener un análisis
            detallado de cada una de ellas. Nuestra herramienta extraerá automáticamente las entidades mencionadas en
            las noticias, identificará los tópicos principales y determinará el tono general de la noticia (positivo,
            negativo o neutral). Todo esto te permitirá obtener una visión completa y precisa de lo que se está hablando
            en los medios de comunicación sobre un tema específico.

            <!-- Tweet
            "¡Mantente informado con nuestra herramienta de análisis de noticias! Busca noticias relacionadas a un tema, obtén entidades, tópicos y tono automáticamente. #noticias #analisis #entidades #topicos #tono" -->
        </p>

        <p>Este análisis se construye utilizando modelos cuya precisión es menor a la que podría dar un humano, por lo
            que sus resultados pueden mejorarse constantemente después de que el usuario final los evalúe. Esta es una
            herramienta de apoyo al trabajo de quienes realizan análisis sobre diversas fuentes y tipos de información;
            no está destinado a reemplazarlos 🤗</p>
    </h3>

    <h3 class="w-full p-bottom">
        <table class="inside-cell">
            <thead class="inside-cell">
                <tr>
                    <th colspan="2">Ejemplos de resultados</th>
                </tr>
            </thead>
            <tbody class="inside-cell">
                <tr class="inside-cell">
                    <td class="center-text">
                        <a href="../../../../assets/img/compai-me-apps-topics-analyzer-example-1.webp" target="_blank">
                            <img src="../../../../assets/img/compai-me-apps-topics-analyzer-example-1.webp" alt="img1"
                                class="example-image img-shadow">
                        </a>
                    </td>
                    <td class="center-text">
                        <a href="../../../../assets/img/compai-me-apps-topics-analyzer-example-2.webp" target="_blank">
                            <img src="../../../../assets/img/compai-me-apps-topics-analyzer-example-2.webp" alt="img1"
                                class="example-image img-shadow">
                        </a>
                    </td>
                </tr>
                <tr>
                    <td class='h-padding-10'>
                        Problemas con el agua en Cuba
                    </td>
                    <td class='h-padding-10'>
                        Estado de la migración en Cuba 2023
                    </td>
                </tr>
            </tbody>
        </table>
    </h3>

    <form *ngIf="providerInfoForm !== undefined" name="provider-info" class="flex-auto px-20"
        [formGroup]="providerInfoForm">
        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="text">
                Tema a analizar
            </label>
            <input type="text" name="text-input"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Texto..." formControlName="ptexto" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['ptexto'].invalid && (providerInfoForm.controls['ptexto'].dirty || providerInfoForm.controls['ptexto'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['ptexto'].errors?.required">
                    El tema debe ser especificado.
                </div>
            </div>
        </div>

        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="token_compai">
                Token de CompAI
            </label>
            <input type="password" name="token-compai"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Token ..." formControlName="ptoken_compai" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['ptoken_compai'].invalid && (providerInfoForm.controls['ptoken_compai'].dirty || providerInfoForm.controls['ptoken_compai'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['ptoken_compai'].errors?.required">
                    El token de CompAI debe ser especificado.
                </div>
            </div>

            <div *ngIf="tokenHasError[0]" class="alert alert-danger">
                <div>{{tokenHasError[1]}}</div>
            </div>
        </div>

        <div class="text-center mt-6">
            <button
                class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="submit" (click)="processArticleAsync()">
                <span *ngIf='!isProcessingArticle'>Procesar</span>

                <span *ngIf='isProcessingArticle'>
                    Procesando
                    <span *ngIf='progressInfo === undefined'>...</span>
                    <span *ngIf='progressInfo !== undefined && progressInfo.total > 0'> [ {{progressInfo.current}} /
                        {{progressInfo.total}} ]</span>
                </span>
            </button>
            <div *ngIf="progressInfo.description">[{{progressInfo.description}}]</div>
            <div *ngIf='isProcessingArticle && progressInfo.position !== null && !myIsNaN(progressInfo.position)'>
                [Hay {{progressInfo.position + 1}} tarea{{progressInfo.position === 0?'':'s'}} en cola antes de que
                comience la suya.]
            </div>
            <div *ngIf="hasErrorProcessing[0]" class="alert alert-danger">
                <div>{{hasErrorProcessing[1]}}</div>
            </div>
        </div>
    </form>

    <div class="w-full mb-12 px-4" [hidden]='!showResults'>
        <section>
            <!-- ENTIDADES -->
            <div class="w-full mb-12 ">
                <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
                    <div class="rounded-t mb-0 px-4 py-3 border-0">
                        <div class="flex flex-wrap items-center">
                            <div class="relative w-full  max-w-full flex-grow flex-1">
                                <h3 class="font-semibold text-lg text-blueGray-700">
                                    Entidades
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="block w-full overflow-x-auto">
                        <!-- Projects table -->
                        <table class="items-center w-full bg-transparent border-collapse">
                            <thead>
                                <tr>
                                    <th
                                        class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                        Tipo
                                    </th>
                                    <th
                                        class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                        Valores
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let type of nerTypes">
                                    <th
                                        class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left flex items-center">
                                        <span class="ml-3 font-bold text-blueGray-600">
                                            {{type[2]}}
                                        </span>
                                    </th>
                                    <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm p-4">
                                        {{join(', ', type[1])}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <app-dependency-dashboard [type]='"entities"' [nodes]='nodes' [edges]='edges'></app-dependency-dashboard>

        <div style="margin-top: 30px;"></div>

        <app-dependency-dashboard [type]='"topics"' [nodes]='nodesTopics' [edges]='edgesTopics'>
        </app-dependency-dashboard>
    </div>

    <div class="w-full mb-12 px-4" [hidden]='!showResults || itemsLength === 0'>
        <section>
            <h2>{{itemsTitle}}</h2>

            <!-- <h3 *ngIf='items !== undefined'>Cantidad: {{itemsLength}}</h3> -->
            <h3>Cantidad: {{itemsLength}}</h3>

            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full max-w-full flex-grow flex-1">
                            <h2 class="text-blueGray-700 text-xl font-semibold">Tópicos</h2>
                        </div>
                    </div>
                </div>
                <div class="p-4 flex-auto">
                    <div class="relative h-350">
                        <canvas id="bar-chart-topics"></canvas>
                    </div>
                </div>
            </div>

            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full max-w-full flex-grow flex-1">
                            <h2 class="text-blueGray-700 text-xl font-semibold">Entidades</h2>
                        </div>
                        <p>
                            <select title="ner-select" [(ngModel)]="selectedType"
                                (ngModelChange)="onNERSelectedChanged($event)">
                                <option *ngFor="let type of commentsNerLabels">
                                    <span>{{getLongKey(type)}}</span>
                                </option>
                            </select>
                        </p>
                    </div>
                </div>
                <div class="p-4 flex-auto">
                    <div class="relative h-350">
                        <canvas id="bar-chart-ner"></canvas>
                    </div>
                </div>
            </div>

            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full max-w-full flex-grow flex-1">
                            <h2 class="text-blueGray-700 text-xl font-semibold">Sentimiento</h2>
                            <h4 class="text-blueGray-700 text-xl font-semibold">
                                Se expresa en una escala del 1 al 5, donde 1 se refiere a una expresión negativa
                                mientras que 5 es una positiva.
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="p-4 flex-auto">
                    <div class="relative h-350">
                        <canvas id="bar-chart-sentiment"></canvas>
                    </div>
                </div>
            </div>

        </section>

        <div *ngIf="dataSource.length > 0">
            <h2 class="mt-50">Área de filtrado de {{ itemsTitle | lowercase }}</h2>
            <app-comments-explorer class="w-full" [dataSource]="dataSource" [token]="token">
            </app-comments-explorer>
        </div>
    </div>
</div>
